// @flow

import { useEffect, useState } from 'react';

export function useIsMobile(): boolean {
  const [state, setState] = useState<boolean>(isMobile());
  useEffect(
    () => {
      const handler = () => setState(isMobile());
      window.addEventListener('resize', handler);
      return () => window.removeEventListener('resize', handler);
    },
    [setState]
  );
  return state;
}

function isMobile(): boolean {
  return Boolean(
    navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
  );
}
